import { api } from '../client';

export type LocationType = 'HUB' | 'SITE' | 'DEPOT' | 'SUPPLIER';

export interface Location {
  id: string;
  name: string;
  code: string;
  type: LocationType;
  companyId: string;
  company?: { id: string; name: string; displayName: string };
  address?: {
    street?: string;
    city?: string;
    state?: string;
    country?: string;
    postalCode?: string;
  };
  coordinates?: { lat: number; lng: number };
  contact?: { name?: string; email?: string; phone?: string };
  isActive: boolean;
  _count?: {
    inventoryLevels: number;
    shipmentOrigins: number;
    shipmentDestinations: number;
  };
  createdAt: string;
  updatedAt: string;
}

export interface CreateLocationDto {
  name: string;
  code: string;
  type: LocationType;
  companyId: string;
  address?: Location['address'];
  coordinates?: Location['coordinates'];
  contact?: Location['contact'];
  isActive?: boolean;
}

export interface QueryLocationParams {
  search?: string;
  type?: LocationType;
  isActive?: boolean;
  companyId?: string;
  page?: number;
  limit?: number;
}

export const locationsApi = {
  async getAll(params?: QueryLocationParams) {
    const response = await api.get<{
      data: Location[];
      meta: { total: number; page: number; limit: number; totalPages: number };
    }>('/api/locations', { params });
    return response.data;
  },

  async getById(id: string) {
    const response = await api.get<Location>(`/api/locations/${id}`);
    return response.data;
  },

  async getInventory(id: string, params?: { page?: number; limit?: number }) {
    const response = await api.get(`/api/locations/${id}/inventory`, { params });
    return response.data;
  },

  async create(data: CreateLocationDto) {
    const response = await api.post<Location>('/api/locations', data);
    return response.data;
  },

  async update(id: string, data: Partial<CreateLocationDto>) {
    const response = await api.patch<Location>(`/api/locations/${id}`, data);
    return response.data;
  },

  async delete(id: string) {
    const response = await api.delete<Location>(`/api/locations/${id}`);
    return response.data;
  },
};
